import { IDateRange } from "../../shared/DateRangePicker/DateRangePicker";
import { ALL_TIME_LABEL, CSV_FILE_NAME_BASE } from "./constants";
import { formatKyivDate as formatReportDate } from "../../shared/Utils/DateOperations/formatKyivDate";

// Shared with the school page's LMS tab: one formatter, one notion of "the report's day".
export { formatReportDate };

// "01.02.2026 - 28.02.2026", "з 01.02.2026", "по 28.02.2026" or "весь час" — the same wording the
// CSV export puts into its first line, so screen and file agree.
export const describePeriod = ({ startDate, endDate }: IDateRange): string => {
  const from = startDate ? formatReportDate(startDate) : null;
  const to = endDate ? formatReportDate(endDate) : null;

  if (from && to) return `${from} - ${to}`;
  if (from) return `з ${from}`;
  if (to) return `по ${to}`;

  return ALL_TIME_LABEL;
};

const isoDay = (value: string | Date): string =>
  new Date(value).toISOString().slice(0, 10);

// Mirrors the backend's Content-Disposition name: lms-connections[_from][_to].csv.
export const exportFileName = ({ startDate, endDate }: IDateRange): string => {
  const parts = [CSV_FILE_NAME_BASE];

  if (startDate) parts.push(isoDay(startDate));
  if (endDate) parts.push(isoDay(endDate));

  return `${parts.join("_")}.csv`;
};
